import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalPage({ titlePl, titleEn, lang, children, testId }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8" data-testid={testId}>
      <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-[#a8adbd] hover:text-white">
        <ArrowLeft className="h-4 w-4" />{lang === "pl" ? "Powrót" : "Back"}
      </Link>
      <h1 className="mb-2 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
        {lang === "pl" ? titlePl : titleEn}
      </h1>
      <p className="mb-10 text-sm text-[#a8adbd]">
        {lang === "pl" ? "Ostatnia aktualizacja:" : "Last updated:"} 2026-02
      </p>
      <div className="prose-legal space-y-6 text-sm leading-relaxed text-[#dcdde6]">
        {children}
      </div>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="mt-8 font-display text-xl font-semibold text-white">{children}</h2>;
}

export function P({ children }) {
  return <p className="text-[#dcdde6]">{children}</p>;
}

export function UL({ children }) {
  return <ul className="ml-5 list-disc space-y-1.5 text-[#dcdde6]">{children}</ul>;
}

export function Placeholder({ children }) {
  return (
    <span className="rounded bg-[#fdb022]/15 px-1.5 py-0.5 font-mono text-xs text-[#fdb022]">
      {children}
    </span>
  );
}
